import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

export const UpcomingCalendar = ({ value, onChange }: UpcomingCalendarProps): JSX.Element => {
    return <Calendar value={value} onChange={onChange} className="table-shadow" minDate={new Date()} />;
};

interface UpcomingCalendarProps {
    value: Date;
    onChange: (date: Date) => void;
}
